<template>
    <div class="desktoporderhistory">
        <table class="table">
            <template v-for="(nh, index) in groupedhistory">
                <thead :key="index + 'thead'">
                    <tr>
                        <td colspan="6">
                            <h1>{{ nh.date | formatreldate }}</h1>
                        </td>
                    </tr>
                    <tr v-if="index == 0">
                        <th>Delivered</th>
                        <th>Driver</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody :key="index + 'tbody'">
                    <template v-for="(nt, orderindex) in nh.orders">
                        <tr
                            :class="[{ rowexpanded: expandtable == nt.id }]"
                            @click="expandtable = expandtable == nt.id ? null : nt.id"
                            :key="orderindex + 'mainorderrow'"
                        >
                            <td>
                                {{ nt.created_at | forceformatdate("hh:mm A") }}
                            </td>

                            <td>
                                <template
                                    v-if="
                                        nt.assign_order &&
                                        nt.assign_order.assign_to.avatar
                                    "
                                >
                                    <div
                                        :style="`background-image : url(${nt.assign_order.assign_to.avatar});`"
                                        class="deliveryImage"
                                    ></div>
                                </template>
                            </td>

                            <td>{{ nt.contact_name }}</td>
                            <td>
                                {{ nt.phone_number | VMask("(###) ###-####") }}
                            </td>
                            <td>
                                <div class="deliveryInfo">
                                    <b-row no-gutters>
                                        <b-col cols="3">
                                            <div
                                                class="googleMap"
                                                @click="openMap('point', nt)"
                                            >
                                                <GmapMap
                                                    :options="mapOptions"
                                                    :center="{
                                                        lat: parseFloat(
                                                            nt.shipping_address_latitude
                                                        ),
                                                        lng: parseFloat(
                                                            nt.shipping_address_longitude
                                                        ),
                                                    }"
                                                    :zoom="10"
                                                    map-type-id="roadmap"
                                                >
                                                    <GmapMarker
                                                        :icon="svgMarker"
                                                        :position="{
                                                            lat: parseFloat(
                                                                nt.shipping_address_latitude
                                                            ),
                                                            lng: parseFloat(
                                                                nt.shipping_address_longitude
                                                            ),
                                                        }"
                                                    />
                                                </GmapMap>
                                            </div>
                                        </b-col>

                                        <b-col cols="9">
                                            <div
                                                class="deliveryDateandTime pl-3"
                                            >
                                                <div class="dAddress">
                                                    {{
                                                        nt.shipping_address_street
                                                    }}
                                                    {{
                                                        nt.shipping_address_city
                                                    }}
                                                    {{
                                                        nt.shipping_address_state
                                                    }}
                                                    {{
                                                        nt.shipping_address_zipcode
                                                    }}
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </td>

                            <td>
                                <template v-if="expandtable == nt.id">
                                    <b-iconstack font-scale="2">
                                        <b-icon
                                            stacked
                                            icon="chevron-up"
                                            scale="0.5"
                                        ></b-icon>
                                        <b-icon stacked icon="circle"></b-icon>
                                    </b-iconstack>
                                </template>

                                <template v-else>
                                    <b-iconstack font-scale="2">
                                        <b-icon
                                            stacked
                                            icon="chevron-down"
                                            scale="0.5"
                                        ></b-icon>
                                        <b-icon stacked icon="circle"></b-icon>
                                    </b-iconstack>
                                </template>
                            </td>
                        </tr>

                        <tr
                            class="ordermoredetails"
                            v-if="expandtable == nt.id"
                            :key="orderindex + 'ordermoredetails'"
                        >
                            <td colspan="6">
                                <div class="moredetailsinner">
                                    <b-row>
                                        <b-col cols="5">
                                            <div class="orderTrail">
                                                <div class="orderTrailItem">
                                                    <span
                                                        class="trailType done"
                                                    >
                                                        <b-icon
                                                            icon="file-earmark-text-fill"
                                                        ></b-icon>
                                                    </span>

                                                    <div class="trailDetails">
                                                        <h4>Order created</h4>
                                                        <p>
                                                            {{
                                                                nt.created_at
                                                                    | forceformatdate(
                                                                        "hh:mm A, MMM D YYYY"
                                                                    )
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="orderTrailItem">
                                                    <span
                                                        :class="[
                                                            'trailType',
                                                            {
                                                                done: nt.assign_order,
                                                            },
                                                        ]"
                                                    >
                                                        <b-icon
                                                            icon="person-fill"
                                                        ></b-icon>
                                                    </span>

                                                    <div class="trailDetails">
                                                        <h4>
                                                            Assigned to
                                                            {{
                                                                nt.assign_order
                                                                    ? nt
                                                                          .assign_order
                                                                          .assign_to
                                                                          .name
                                                                    : ""
                                                            }}
                                                        </h4>
                                                        <p>
                                                            {{
                                                                nt.assign_order
                                                                    ? nt
                                                                          .assign_order
                                                                          .created_at
                                                                    : ""
                                                                      | forceformatdate(
                                                                          "h:mm A, MMM D YYYY"
                                                                      )
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="orderTrailItem">
                                                    <span
                                                        :class="[
                                                            'trailType',
                                                            {
                                                                done:
                                                                    nt.status !=
                                                                    'assign',
                                                            },
                                                        ]"
                                                    >
                                                        <b-icon
                                                            icon="check"
                                                        ></b-icon>
                                                    </span>

                                                    <div class="trailDetails">
                                                        <h4>Accepted</h4>
                                                        <template
                                                            v-if="
                                                                nt.status !=
                                                                'assign'
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    accepteddate(
                                                                        nt
                                                                    )
                                                                        | forceformatdate(
                                                                            "h:mm A, MMM D YYYY"
                                                                        )
                                                                }}
                                                            </p>
                                                        </template>

                                                        <template v-else>
                                                            <p>Pending</p>
                                                        </template>
                                                    </div>
                                                </div>

                                                <template
                                                    v-for="(
                                                        amend, index
                                                    ) in amendstatuses(nt)"
                                                >
                                                    <div
                                                        :key="index"
                                                        class="orderTrailItem amendstatuses"
                                                    >
                                                        <span
                                                            :class="[
                                                                `trailType`,
                                                                'done',
                                                            ]"
                                                        >
                                                            <b-icon
                                                                icon="pen-fill"
                                                            ></b-icon>
                                                        </span>

                                                        <div
                                                            :class="[
                                                                `trailDetails orderstatus`,
                                                            ]"
                                                        >
                                                            <h4>Amended</h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    amend.created_at
                                                                        | forceformatdate(
                                                                            "h:mm A, MMM D YYYY"
                                                                        )
                                                                }}
                                                            </p>
                                                            <p>
                                                                {{
                                                                    amend.notes
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </template>

                                                <div class="orderTrailItem">
                                                    <span
                                                        :class="[
                                                            'trailType',
                                                            {
                                                                done:
                                                                    nt.status ==
                                                                        'delivered' ||
                                                                    nt.status ==
                                                                        'confirm',
                                                            },
                                                        ]"
                                                    >
                                                        <b-icon
                                                            icon="box-seam"
                                                        ></b-icon>
                                                    </span>

                                                    <div class="trailDetails">
                                                        <h4>Delivered</h4>

                                                        <template
                                                            v-if="
                                                                nt.status ==
                                                                    'delivered' ||
                                                                nt.status ==
                                                                    'confirm'
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    delivereddate(
                                                                        nt
                                                                    )
                                                                        | forceformatdate(
                                                                            "h:mm A, MMM D YYYY"
                                                                        )
                                                                }}
                                                            </p>
                                                        </template>

                                                        <template v-else>
                                                            <p>
                                                                ETA
                                                                {{
                                                                    nt.order_event_time_range
                                                                        ? `${nt.order_event_time_range}, `
                                                                        : ""
                                                                }}
                                                                {{
                                                                    nt.delivery_date
                                                                        | formatdate(
                                                                            "MMM D"
                                                                        )
                                                                }}
                                                            </p>
                                                        </template>
                                                    </div>

                                                    <template
                                                        v-if="
                                                            nt.status ==
                                                                'delivered' ||
                                                            nt.status ==
                                                                'confirm'
                                                        "
                                                    >
                                                        <div
                                                            class="trailAction pl-5"
                                                        >
                                                            <button
                                                                @click.prevent="
                                                                    checkammendstatus(
                                                                        nt
                                                                    ),
                                                                        $bvModal.show(
                                                                            'cancelDeliverHistory'
                                                                        )
                                                                "
                                                                class="btn btn-outline-primary"
                                                            >
                                                                Amend
                                                            </button>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>

                                            <div class="deliveryProof">
                                                <img
                                                    :src="getdeliverimg(nt)"
                                                    alt=""
                                                />
                                            </div>

                                            <div class="orderContactDetails">
                                                <div class="contactItem">
                                                    <div class="orderNote">
                                                        {{
                                                            nt.order_notes
                                                                ? nt.order_notes
                                                                : "No notes"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>

                                        <b-col cols="5" offset="2">
                                            <div class="orderSummary">
                                                <div class="orderSummaryHeader">
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <h4>
                                                                Order
                                                                {{
                                                                    nt.order_number
                                                                }}
                                                                summary

                                                                <span
                                                                    class="dozen"
                                                                >
                                                                    {{
                                                                        nt.numberofboxes
                                                                    }}
                                                                    Dozen
                                                                </span>
                                                            </h4>
                                                        </b-col>
                                                    </b-row>
                                                </div>

                                                <div class="orderBreakdown">
                                                    <template
                                                        v-for="(
                                                            box, index
                                                        ) in grouporderbox(
                                                            nt.orderboxitems
                                                        )"
                                                    >
                                                        <div
                                                            :key="index"
                                                            class="orderBreakdownItem"
                                                        >
                                                            <div
                                                                class="orderboxheader"
                                                            >
                                                                <span
                                                                    class="orderNumber"
                                                                    >{{
                                                                        box.count
                                                                    }}</span
                                                                >
                                                                -
                                                                <span
                                                                    class="boxname"
                                                                    >{{
                                                                        box.box_name
                                                                    }}
                                                                </span>
                                                            </div>

                                                            <div
                                                                class="flavorlist"
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        flavor,
                                                                        index
                                                                    ) in groupflavors(
                                                                        box.flavors
                                                                    )"
                                                                >
                                                                    <span
                                                                        :key="
                                                                            index
                                                                        "
                                                                        class="flavorname"
                                                                        >{{
                                                                            flavor.name
                                                                        }}</span
                                                                    >
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </template>
        </table>
    </div>
</template>

<script>
/**
 * Declerations
 */
// MIXINS
import {adminorderhistorymixins} from '@/mixins/adminorderhistorymixins'

export default {
    mixins : [adminorderhistorymixins],
    mounted() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });
    },
};
</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.desktoporderhistory {
    .table {
        td,
        th {
            border: none;
            vertical-align: middle;
        }

        thead {
            th {
                font-weight: 800;
                text-transform: uppercase;
                font-size: 13px;

                &:first-child {
                    padding-left: 60px;
                }
            }
        }

        tbody {
            position: relative;

            &::after {
                content: "";
                width: 120vw;
                height: 10px;
                left: -20vw;
                border-bottom: 10px solid white;
                display: block;
                position: absolute;
            }

            tr {
                td {
                    &:first-child {
                        padding-left: 60px;
                    }

                    &:nth-child(4) {
                        white-space: nowrap;
                    }

                    .bi-circle {
                        color: $lightgrey2;
                    }
                }

                &.rowexpanded {
                    background-color: #fff;
                    border-bottom: 1px solid $lightgrey2;
                }

                &.ordermoredetails {
                    background-color: #fff;
                    td {
                        padding-top: 30px;
                        padding-left: 0;

                        .moredetailsinner {
                            padding-left: 120px;
                        }
                    }
                }
            }
        }
    }

    .vue-map-container {
        min-height: 60px;
        height: 100%;
    }

    h1 {
        font-size: 20px;
        font-weight: 700;
        color: $primaryColor;
        margin-top: 15px;
    }

    .historyItem {
        padding-top: 30px;
        border-bottom: 10px solid $lightgrey;
    }

    .deliveryImage {
        flex: 0 0 50px;
        width: 50px;
        height: 50px;
        display: block;
        border-radius: 100%;
        background-size: cover;
        background-position: center;
        margin-right: 15px;

        svg {
            border-radius: 100%;
            width: 100%;
            height: 100%;
            border: 1px solid $grey;
            padding: 15px;

            &.b-icon.bi {
                color: $grey;
            }
        }
    }

    .orderTrail {
        padding-left: 30px;

        .amendstatuses {
            svg {
                font-size: 14px;
            }

            .orderstatus {
                p {
                    text-transform: none;
                }
            }
        }

        .orderTrailItem {
            display: flex;
            border-left: 1px solid $lightgrey2;

            &:last-child {
                border: none;
            }

            .trailType {
                width: 50px;
                height: 50px;
                flex: 0 0 50px;
                margin-right: 15px;
                margin-left: -25px;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $lightgrey;
                font-size: 25px;

                &.done {
                    background-color: $primaryColor;
                    color: white;
                }
            }

            .trailDetails {
                h4 {
                    font-size: 20px;
                    font-weight: 700;
                    margin-bottom: 0;
                }
            }

            .trailAction {
                .btn {
                    width: 130px;
                    height: 40px;
                    padding: 0;
                }
            }
        }
    }

    .historyTrail {
        display: flex;
        padding-top: 15px;
        padding-bottom: 15px;

        .trailTime {
            color: $grey;
            margin-right: 15px;
            display: block;
            white-space: nowrap;
        }

        .tailDetails {
            display: flex;
            width: 100%;

            h3 {
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 0;
            }

            p {
                color: $grey;
                margin-bottom: 0;
            }
        }
    }

    .deliveryProof {
        margin-bottom: 20px;

        img {
            width: 100%;
            max-width: 300px;
            margin-left: auto;
            margin-right: auto;
            display: table;
        }
    }

    .orderContactDetails {
        color: $grey;

        .contactItem {
            margin-bottom: 10px;

            .orderNote {
                background-color: lighten($color: $primaryColor, $amount: 59);
                padding: 15px;
            }
        }
    }

    .orderSummary {
        padding-top: 30px;

        .orderSummaryHeader {
            margin-bottom: 20px;

            h4 {
                font-size: 18px;
                font-weight: 800;
                margin-bottom: 0;
            }

            .dozen {
                font-weight: 300;
                color: $grey;
                text-align: left;
            }
        }

        .orderBreakdown {
            padding-left: 15px;

            .orderBreakdownItem {
                color: $primaryColor;
                font-size: 15px;
                margin-bottom: 10px;

                .orderNumber {
                    font-weight: 700;
                }
            }
        }
    }

    .orderBreakdown {
        .orderBreakdownItem {
            cursor: pointer;

            .orderboxheader {
                display: flex;
                align-items: center;

                .b-icon.bi {
                    font-size: 12px;
                }

                .orderNumber {
                    margin-right: 10px;
                }

                .boxname {
                    margin-left: 10px;
                    font-weight: 600;
                    margin-right: 10px;
                }
            }

            .flavorlist {
                padding-left: 30px;
                color: $grey;

                span {
                    &::after {
                        content: ", ";
                    }

                    &:last-child {
                        &::after {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
